import { render, staticRenderFns } from "./center-bottom.vue?vue&type=template&id=0db67e6e&scoped=true&"
import script from "./center-bottom.vue?vue&type=script&lang=js&"
export * from "./center-bottom.vue?vue&type=script&lang=js&"
import style0 from "./center-bottom.vue?vue&type=style&index=0&id=0db67e6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db67e6e",
  null
  
)

export default component.exports